<template>
    <div class="item-list-v2" v-if="isInit">
        <div v-if="field.name" class="label-item">
            <p class="label-text">{{ field.desc }}</p>
            <el-tooltip class="item" effect="light" placement="bottom-start">
                <div slot="content">
                    - name: <strong>{{ field.name }}</strong><br/>
                    - 可以设置字段数量；
                    - 可以设置多项，点击 + 号新增；
                </div>
                <i class="label-icon el-icon-info"></i>
            </el-tooltip>
        </div>
        <div class="no-item" v-if="!field.def_val.list || !field.def_val.list.length">暂无内容，点击 + 号新增</div>
        <el-form ref="form" :model="field" label-width="120px">
            <el-form-item
                class="input-row"
                label="字段数量：">
                <el-input-number v-model="field.def_val.extra" :min="2" :max="6" label="字段数量"></el-input-number>
                <el-button class="extra-sure-btn" @click="extraSure">点击更改字段数量：p1 - p{{ field.def_val.extra }}</el-button>
            </el-form-item>
            <draggable 
                :list="field.def_val.list"
                :options="draggableOpt"
                class="item-drag-area">
                <div
                    class="input-group drag-item"
                    v-for="(item, index) in field.def_val.list"
                    :key="index">
                    <span class="group-label">{{ `第(${index + 1})项` }}</span>
                    <template v-for="(item2, key) in initPkey">
                        <el-form-item
                            :key="key"
                            class="input-row"
                            :label="key"
                            :prop="`def_val.list[${index}].${key}`"
                            :rules="fieldRules">
                            <el-input class="field-input" v-model="item[key]" :placeholder="`请填写'${field.desc || ''}(${key})'的内容`"></el-input>
                            <renderPreview :val="item[key]"></renderPreview>
                        </el-form-item>
                    </template>
                    
                    <el-button
                        class="remove-btn"
                        @click="remove(index)"
                        icon="el-icon-delete"
                        title="删除该项"></el-button>
                    <el-button
                        class="move-btn"
                        icon="el-icon-rank"
                        title="拖动此项"></el-button>
                </div>
            </draggable>
            <el-form-item>
                <el-button type="primary" class="add-btn" @click="add">+</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import moment from 'moment';
import draggable from 'vuedraggable';
import Vue from 'vue';

const renderPreview = Vue.component('render-preview', {
    functional: false,
    props: ['val'],
    methods: {
        openUrl(url) {
            window.open(url);
        }
    },
    render: function (h) {
        const { val } = this;
        let isUrl = false;
        if (/^http(s)?:\/\//.test(val)) {
            isUrl = true;
        }
        return (
            <div class="render-preview">
                {
                    isUrl ? <el-button class="render-preview-btn" icon="el-icon-view" onClick={this.openUrl.bind(this, val)}>预览</el-button> : null
                }
            </div>
        )
    }
});

export default {
    name: 'item-list-v2',
    props: ['field', 'autoInit'],
    data() {
        return {
            fieldRules: {
                required: false,
                message: `请填写内容`,
                trigger: 'blur'
            },
            draggableOpt: {
                handle: '.move-btn',
                animation: 150
            },
            initPkey: {
                p1: '',
                p2: '',
                p3: '',
                p4: '',
            },
            isInit: this.autoInit
        }
    },
    components: {
        draggable,
        renderPreview
    },
    watch: {
        'field'(val) {
            if (!this.field.def_val.list.length) {
                this.add();
            }
        }
    },
    methods: {
        initData() {
            this.isInit = true;
        },
        add() {
            this.field.def_val.list.push(_.cloneDeep(this.initPkey));
        },
        moveItemHandler(e) {
            e.stopPropagation()
        },
        remove(index) {
            this.field.def_val.list.splice(index, 1);
        },
        fieldBeReady() {
            // 确认组件是否就绪
            return this.$refs['form'];
        },
        getResField() {
            let isValidate = false;
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    isValidate = true;
                } else {
                    isValidate = false;
                }
            });
            if (!isValidate) {
                return;
            }
            return this.field;
        },
        extraSure() {
            let tmpObj = {}
            for(let i = 1; i <= this.field.def_val.extra; i ++){
                tmpObj[`p${i}`] = '';
            }
            this.initPkey = tmpObj;
        }
    },
    computed: {
    },
    mounted() {
        this.extraSure();
    }
}
</script>
<style lang="less">
    @import (reference) '../../styles/public.less';
    .item-list-v2 {
        .label-item();
        .el-form-item {
            margin-bottom: 22px;
        }
        .no-item {
            text-align: center;
            line-height: 40px;
            color: #666;
        }
        .form-label {
            font-weight: 700;
            line-height: 24px;
            font-size: 14px;
        }
        .input-group {
            border-bottom: solid 1px #ddd;
            position: relative;
        }
        .field-input {
            width: 85%;
        }
        .render-preview {
            display: inline-block;
            margin-left: 10px;
            .render-preview-btn {
                padding: 12px;
                color: #20a0ff;
            }
            
        }
        .remove-btn {
            position: absolute;
            top: 40px;
            left: 0px;
            padding: 10px;
            color: red;
        }
        .move-btn {
            position: absolute;
            top: 100px;
            left: 0px;
            padding: 10px;
            margin-left: 0;
            color: #20a0ff;
        }
        .add-btn {
            margin-top: 10px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/compEditForm/itemListV2.vue